import React from "react";
import { CheckoutAction, CheckoutState, CheckoutActionTypes } from "@checkout-core/reducers/Checkout";

export interface CheckoutContextValue {
    checkoutState: CheckoutState;
    setCheckoutState: React.Dispatch<CheckoutAction>;
}

const defaultReducerState: CheckoutState = {
    type: CheckoutActionTypes.SHOW_CART,
    payload: null,
};

export const CheckoutContext = React.createContext<CheckoutContextValue>({
    checkoutState: defaultReducerState,
    setCheckoutState: () => void 0,
});

if (__DEV__) {
    CheckoutContext.displayName = "CheckoutContext";
}
